// extracted by mini-css-extract-plugin
export var card = "_ll-5";
export var cardSelected = "_ll-4";
export var image = "_ll-3";
export var modal = "_ll-0";
export var modalContent = "_ll-1";
export var table = "_ll-2";